export const SETTINGS_ENTER_KEY = 'settings-enter-key';
export const SETTINGS_TOGGLE_SOUND = 'settings-sound';
export const SETTINGS_THREADS_ORDERING = 'settings-threads-ordering';
export const SETTINGS_SET_LOCALE = 'settings-set-locale';
import { initLocale } from '../../locales';


export function toggleEnterKey(payload) {
  	return { type: SETTINGS_ENTER_KEY, payload };
}

export function toggleSound(payload) {
  	return { type: SETTINGS_TOGGLE_SOUND, payload };
}

export function setThreadsOrering(payload) {
  	return { type: SETTINGS_THREADS_ORDERING, payload };
}

export function setLocale(requestedLocale) {
	return (dispatch) => {
		initLocale(requestedLocale).then((finalLocale) => {
			dispatch({ type: SETTINGS_SET_LOCALE, locale: finalLocale });
		});
	}
}



// WEBPACK FOOTER //
// ./src/redux/actions/settingsAction.jsx